export type BaseSize = 'small' | 'medium' | 'large' | 'extraLarge';

export enum DefaultImage {
  Avatar = 'avatar',
  Camera = 'camera',
}
